import React from "react";

const SendArrow = ({ className }) => (
  <svg className={ className } viewBox="-293 385 24 24">
    <path d="M-291 406l21-9-21-9v7l15 2-15 2v7z" />
  </svg>
);

export default SendArrow;
